export function IconTelegramStar() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.956 18.3924L5.80978 21.4628C5.27467 21.782 4.57512 21.6183 4.24732 21.0972C4.08721 20.8426 4.03949 20.5359 4.11494 20.2466L4.91158 17.1929C5.19915 16.0905 5.9737 15.169 7.0265 14.6767L12.6408 12.0515C12.9025 11.9291 13.0128 11.6233 12.8872 11.3684C12.7854 11.1619 12.5552 11.0464 12.3235 11.0855L6.07415 12.1392C4.80379 12.3534 3.50106 12.0117 2.51289 11.2052L0.538661 9.59392C0.0576864 9.20136 -0.00546755 8.50339 0.397604 8.03497C0.593643 7.80713 0.875551 7.66569 1.17983 7.64251L7.21171 7.18277C7.63785 7.15028 8.00922 6.88764 8.17282 6.50305L10.4998 1.03238C10.74 0.467745 11.4047 0.199636 11.9844 0.433541C12.2628 0.545853 12.484 0.761261 12.5993 1.03238L14.9263 6.50305C15.0899 6.88764 15.4612 7.15028 15.8874 7.18277L21.9525 7.64504C22.5781 7.69272 23.0455 8.22531 22.9965 8.83462C22.973 9.12772 22.8306 9.39966 22.6009 9.5904L17.9755 13.4309C17.6497 13.7013 17.5077 14.1269 17.6078 14.532L19.0298 20.2853C19.1767 20.8796 18.8011 21.4772 18.1912 21.6202C17.8979 21.689 17.5887 21.6413 17.3316 21.4879L12.1431 18.3924C11.7789 18.1751 11.3202 18.1751 10.956 18.3924Z"
        fill="#FEA516"
      />
    </svg>
  );
}
